export default __webpack_public_path__ + "static/media/filter.9ade4a22.svg";